import React from "react";
import BookingForm from "../components/BookingForm";

const PasteurHouse = () => {
    return (
        <div className="bg-[#F2F1F0] text-[#144E73] font-sans min-h-screen pt-16 pb-20 px-6">
            <div className="max-w-6xl mx-auto">
                {/* Title */}
                <h1 className="text-4xl md:text-5xl font-bold text-primarymb-10 text-center">
                    Vanderbijlpark – Pasteur – Self-Catering
                </h1>

                {/* Gallery + Description */}
                <div className="grid md:grid-cols-2 gap-10 mb-16 items-start">
                    {/* Gallery */}
                    <div className="grid grid-rows-[auto_1fr] gap-4">
                       <img
                         src="placeholder image.png"
                         alt="pasteur Main Image"
                         className="rounded-lg aspect-[16/9] object-cover border-4 border-[#FEB339]"
                        />
                        <div className="grid grid-cols-2 gap-4">
                            {[...Array(5)].map((_, i) => (
                            <img
                                key={i}
                                src="placeholder image.png"
                                alt={`pasteur Gallery Image ${i + 1}`}
                                className="rounded-lg aspect-[4/3] object-cover border-4 border-[#FEB339]"
                            />
                            ))}
                        </div>
                    </div>

                    {/* Description */}
                    <div>
                        <p className="text-lg leading-relaxed mb-4">
                            Pasteur offers affordable and comfortable group-friendly accommodation in Vanderbijlpark. Ideal for contractors or long-stay guests, it features all the essentials for a pleasant stay.
                        </p>
                        <ul className="list-disc ml-5 text-sm space-y-2">
                            <li>Kitchenette in each unit</li>
                            <li>Wi-Fi available</li>
                            <li>Outdoor braai area</li>
                            <li>Linens and towels included</li>
                            <li>Private, secure parking</li>
                            <li>Group-suitable layout</li>
                        </ul>

                    
                    </div>
                </div>


                {/* Booking Form */}

                <BookingForm hotelName="Pasteur House"/>


            </div>
        </div>
    );
};

export default PasteurHouse;
